import React from 'react';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './AlbumComponent.css'; // Import the CSS file
import yourPhoto from '../assets/yourPhoto.png';
import demo1 from '../assets/demo1.mp3';
import demo4 from '../assets/demo4.mp3';
import demo2 from '../assets/demo2.mp3';
import demo3 from '../assets/demo3.mp3';
import demo5 from '../assets/demo5.mp3';
import demo6 from '../assets/demo6.mp3';   // Replace with your photo path
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import {useState,useRef} from 'react';
import ToastNotification from './ToastNotification';

const tracks = [
  { title: 'Commercials/Ads', src:demo1 },
  { title: 'Explainers', src:demo2 },
  { title: 'Vibrant', src: demo3 },
  { title: 'e-Learning', src: demo4 },
  { title: 'YouTube', src: demo5 },
  { title: 'IVR', src: demo6 },
  
];


const downloadTrack = (src,title) => {
    const link = document.createElement('a');
    link.href = src;
    link.download = `Anushka Demo-${title}.mp3`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    console.log(`Download ${src} as Anushka Demo-${title}.mp3`);
  };

const AlbumComponent = () => {
  const [customLink, setCustomLink] = useState('');
  const [isCopied, setIsCopied] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [isDownloaded, setIsDownloaded] = useState('');


  const downloadAlbum = async () => {
    const zip = new JSZip();
    const folder = zip.folder('anushka rath-voiceovers');
  
    setShowToast(true);

    for (const track of tracks) {
      const response = await fetch(track.src);
      const blob = await response.blob();
      folder.file(track.title + '.mp3', blob);
    }
  
    const content = await zip.generateAsync({ type: 'blob' });
    saveAs(content, 'anushka rath-voiceovers.zip');
    console.log('Download Album');
    setTimeout(4000);
    setIsDownloaded(true);
  };



  const SharePage = () => {
    const baseUrl = window.location.origin;
    const customPath = '/demos';
    const hash='/#';
    const link = `${baseUrl}${hash}${customPath}`;
    setCustomLink(link);

    navigator.clipboard.writeText(link).then(() => {
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 3000); // Reset after 2 seconds
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });

    console.log('Share Page');
    console.log(link);
  };
  
  const [currentTrackIndex, setCurrentTrackIndex] = useState(null);
  const audioRefs = useRef([]);

  const handlePlay = (index) => {
    if (currentTrackIndex !== null && currentTrackIndex !== index) {
      audioRefs.current[currentTrackIndex].audio.current.pause();
    }
    setCurrentTrackIndex(index);
  };

  return (
    <div>
      
        <div className="writes">
    <h2 className="demos-heading">Demos by Anushka Rath</h2>
      </div>
     
    <div className="album-container">
        <img
        src={yourPhoto}
        alt="Profile"
        className="profile-photo"
      />
      <div className="button-container">
      
        <button className="download-button" onClick={downloadAlbum}>
          <i className="fas fa-download"></i>  {isDownloaded ? 'ALBUM DOWNLOADED!' : 'DOWNLOAD ALBUM'}
        </button>
        <button className="share-button" onClick={SharePage}>
          <i className="fas fa-link"></i> {isCopied ? 'COPIED!' : 'COPY ALBUM LINK'} {/* Different share icon */}
        </button>
        <ToastNotification show={showToast} onClose={() => setShowToast(false)} />
      </div>
      {tracks.map((track, index) => (
        <div key={index} className="track-container">
          <h6>{track.title}</h6>
          <AudioPlayer
            ref={(el) => (audioRefs.current[index] = el)}
            src={track.src}
            onPlay={() => handlePlay(index)}
            onError={() => console.error(`Error playing ${track.title}`)}
            aria-label={`Audio player for ${track.title}`}
            autoPlay={false}
            
          />
          <button
            className="track-download-button"
            onClick={() => downloadTrack(track.src, track.title)}
          >
            <i className="fas fa-download"></i> DOWNLOAD TRACK
          </button>
          
        </div>
      ))}
    </div>
    

    </div>
  );
};

export default AlbumComponent;
